export enum PurchaserSwitchStep {
  PropertyLookup,
  Energy,
  Purchaser,
  Consent,
  Summary,
  Confirmation,
}
